import { defineNuxtPlugin } from 'nuxt/app';
import VueGallery from 'vue-gallery';

// https://github.com/RobinCK/vue-gallery
export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('VGallery', VueGallery);
});
